<template>
  <div class="contacto">

    <div class=" color-blanco" :style="'background-image: url(https://nncms.actstudio.xyz/' +
        contacto.cover.path +
        ')' " style="background-size: cover; background-position: 25% 25%;  height:calc((100vh - 110px) / 2);">
        <div style="background: #5c27b2a6; position: relative; height:calc((100vh - 110px) / 2);" >   
            <v-container>
                <v-row class="py-10" justify="center" style="height:calc((100vh - 110px) / 2);" align="center" >
                    <v-col class="text-center" cols="12">
                        <span class="montserrat bold enfasis-size"> {{contacto.titulo}} </span>
                        <!-- <span class="d-block mb-5 single-item-size"> {{contacto.descripcion}} </span> -->
                        
                        
                    </v-col>
                    
                </v-row>
                
            </v-container>
        </div>
    </div>

    <v-container>
        <v-row justify="center" class="py-3">
            <v-col cols="auto" md="8" class="text-center">
                <span class="color-morado-2" v-html="contacto.descripcion" ></span>
            </v-col>
            <v-col cols="12" class="text-center pt-0">
              <v-btn href="https://www.facebook.com/Neutral-Networks-107188574220774" target="_blank" icon color="#5C27B2" class="mx-6">
                <v-icon size="44">mdi-facebook</v-icon>
              </v-btn>

              <v-btn href="https://www.linkedin.com/company/neutralnetworks/" target="_blank" icon color="#5C27B2" class="mx-6">
                <v-icon size="44">mdi-linkedin</v-icon>
              </v-btn>

              <v-btn href="https://twitter.com/NeutralNetworks" target="_blank" icon color="#5C27B2" class="mx-6">
                <v-icon size="44">mdi-twitter</v-icon>
              </v-btn>

            </v-col>
        </v-row>
    </v-container>
    <!-- <v-img style="position: absolute; top: -96px; width: 100%; height: 100vh; object-fit: cover; z-index: 0;" :src="'https://nncms.actstudio.xyz/'+contacto.cover.path" ></v-img> -->
    <!-- <div
      style="background-size: cover; position: relative; height: 100vh"
      :style="
        'background-image: url(https://nncms.actstudio.xyz/' +
        contacto.cover.path +
        ')'
      "
    >
      <div
        style="
          z-index: 1;
          position: relative;
          background: rgb(90, 35, 178);
          background: linear-gradient(
            0deg,
            rgba(90, 35, 178, 0) 12%,
            rgba(90, 35, 178, 0.5452381636248249) 52%,
            rgba(90, 35, 178, 1) 100%
          );
          margin-bottom: 100px;
        "
      >
        <v-container fluid class="px-16 py-0">
          <v-row style="height: 200px; color: #fff" align="end">
            <v-col cols="12" md="12" class="pt-16">
              <span class="titulos-size">{{ contacto.titulo }}</span>
            </v-col>
          </v-row>
          <v-row
            style="height: calc((100vh - 96px - 300px) / 2)"
            align="center"
            align-md="start"
          >
            <v-col cols="12" md="12">
              <div
                class="montserrat bold titulos-size d-none d-sm-block"
                style="color: #fff"
                v-html="contacto.descripcion"
              ></div>
              <hr class="mt-6" style="max-width: 70%; color: #fff" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div> -->

    <div class="mb-12">
      <v-container class="background-morado">
        <v-form ref="form" lazy-validation v-model="valid">
          <v-container class="pa-8 pa-md-16 py-0 py-md-0">
            <v-row justify-md="center" id="contactForm">
              <v-col cols="12" md="6" class="py-0">
                <template v-if="locale == 'en'">
                    <v-text-field
                      label="Name"
                      outlined
                      color="#5C27B2"
                      v-model="form.nombre"
                      :rules="emptyRule"
                      required
                    ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Nombre"
                    outlined
                    color="#5C27B2"
                    v-model="form.nombre"
                    :rules="emptyRule"
                    required
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <template v-if="locale == 'en'">
                  <v-text-field
                    label="Email"
                    outlined
                    color="#5C27B2"
                    v-model="form.correo"
                    :rules="emailRule"
                    required
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Correo"
                    outlined
                    color="#5C27B2"
                    v-model="form.correo"
                    :rules="emailRule"
                    required
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <template v-if="locale == 'en'">
                  <v-text-field
                    label="Phone Number"
                    outlined
                    color="#5C27B2"
                    v-model="form.telefono"
                    :rules="phoneRule"
                    required
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Teléfono"
                    outlined
                    color="#5C27B2"
                    v-model="form.telefono"
                    :rules="phoneRule"
                    required
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <template v-if="locale == 'en'">
                  <v-text-field
                    label="City"
                    outlined
                    color="#5C27B2"
                    v-model="form.ciudad"
                    :rules="emptyRule"
                    required
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Ciudad"
                    outlined
                    color="#5C27B2"
                    v-model="form.ciudad"
                    :rules="emptyRule"
                    required
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12 py-0">
                <template v-if="locale == 'en'">
                  <v-select
                    :items="['Metro','Link','Next']"
                    label="Select an option"
                  ></v-select>
                </template>
                <template v-else>
                  <v-select
                    :items="['Metro','Link','Next']"
                    label="Solución de interés"
                    outlined
                    color="#5C27B2"
                  ></v-select>
                </template>
              </v-col>
              <v-col cols="12 py-0">
                <template v-if="locale == 'en'">
                  <v-text-field
                    label="Company"
                    outlined
                    color="#5C27B2"
                    :rules="emptyRule"
                    required
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Empresa"
                    outlined
                    color="#5C27B2"
                    :rules="emptyRule"
                    required
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="12" class="py-0">
                <template v-if="locale == 'en'">
                    <v-textarea
                      outlined
                      name="input-7-4"
                      label="Message"
                      color="#5C27B2"
                      v-model="form.mensaje"
                      :rules="emptyRule"
                      required
                    ></v-textarea>
                </template>
                <template v-else>
                  <v-textarea
                    outlined
                    name="input-7-4"
                    label="Mensaje"
                    color="#5C27B2"
                    v-model="form.mensaje"
                    :rules="emptyRule"
                    required
                  ></v-textarea>
                </template>
              </v-col>

              <v-col
                cols="auto"
                style="color: #5c27b2"
                class="text-center py-0"
              >
                <v-checkbox
                  color="#5C27B2"
                  hide-details="true"
                  class="py-0 my-0"
                  :rules="emptyRule"
                  required
                >
                  <template v-slot:label class="py-0">
                    <template v-if="locale == 'en'">
                      <div
                        style="color: #5c27b2; padding: 0"
                        class="single-item-size"
                      >
                        I confirm that I have read and accept the
                        <router-link
                          to="/terminos-y-condiciones"
                          style="color: blue; text-decoration: none"
                          >Terms</router-link
                        >
                        and
                        <router-link
                          to="/terminos-y-condiciones"
                          style="color: blue; text-decoration: none"
                          >conditions.</router-link
                        >
                      </div>
                    </template>
                    <template v-else>  
                      <div
                        style="color: #5c27b2; padding: 0"
                        class="single-item-size"
                      >
                        Confirmo que he leído los
                        <router-link
                          to="/terminos-y-condiciones"
                          style="color: blue; text-decoration: none"
                          >Términos</router-link
                        >
                        y
                        <router-link
                          to="/terminos-y-condiciones"
                          style="color: blue; text-decoration: none"
                          >condiciones.</router-link
                        >
                      </div>
                    </template>

                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col class="text-center">
                <template v-if="locale == 'en'">
                    <v-btn
                    outlined
                    x-large
                    color="#5C27B2"
                    :disabled="!valid"
                    @click="validateFields()"
                    >Send</v-btn
                  >
                </template>
                <template v-else>
                  <v-btn
                    outlined
                    x-large
                    color="#5C27B2"
                    :disabled="!valid"
                    @click="validateFields()"
                    >Enviar</v-btn
                  >
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-snackbar v-model="snackbar">
          Información enviada

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </div>

    <div v-if="false" class="atencion mt-12" style="background-color: #d6d6d6">
      <v-container style="color: #5c27b2" class="py-16">
        <!-- <v-row class="pb-7">
          <v-col class="text-center">
            <span
              class="titulos-size color-morado"
              style="color: #5c27b2"
              v-html="contacto.tituloAtencion"
            >
            </span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="5" md="5" class="text-center">
            <span class="d-block">{{ contacto.tituloSede1 }} </span>
            <v-img
              src="../assets/img/telefonos-nn-1.svg"
              width="15"
              class="d-inline-block mr-2"
              style="vertical-align: -10%"
            ></v-img>
            <span class="d-inline-block subtitulo-bold">{{
              contacto.telefonoSede1
            }}</span>
          </v-col>
        </v-row> -->

        <!-- <v-row class="pb-7">
          <v-col class="text-center">
            <template v-if="locale != 'en'">
              <span class="titulos-size color-morado" style="color: #5c27b2"
                >Solicita más información
              </span>
            </template>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="5" md="5" class="text-center">
            <router-link class="d-block subtitulo-bold" to="/renta-servicios" style="color: #5C27B2; text-decoration: none;">Renta de Servicios</router-link>
            <router-link class="d-block subtitulo-bold" to="/duenos-y-arrendadores" style="color: #5C27B2; text-decoration: none;">Dueños de Activos y Arrendadores</router-link>
          </v-col>
        </v-row> -->
      </v-container>
    </div>
<!-- 
    <div>
      <v-container
        fluid
        style="background-color: #2a0d56"
        class="py-12 py-sm-0"
      >
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" class="px-0 py-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3595.7431409969954!2d-100.31914798438348!3d25.679808083674118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662951dab4c5ad5%3A0x75cfe810cef4d58a!2sNeutral%20Networks!5e0!3m2!1ses!2smx!4v1605910837414!5m2!1ses!2smx"
              width="100%"
              height="450"
              frameborder="0"
              style="border: 0"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto" class="px-8">
                <div style="max-width: 400px">
                  <span>{{ contacto.direccionSede1 }} </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto" class="px-8">
                <div style="max-width: 400px">
                  <span>{{ contacto.direccionSede2 }} </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="px-0 py-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.510920092348!2d-99.1754097844688!3d19.39031858690838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ffc86050fccb%3A0x3dd8dbb6984f9b9e!2sNeutral%20Networks!5e0!3m2!1ses!2smx!4v1605911074093!5m2!1ses!2smx"
              width="100%"
              height="450"
              frameborder="0"
              style="border: 0"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      contacto: {
        cover: {
          path: "",
        },
      },
      snackbar: false,
      valid: true,
      checkbox: false,
      form: {
        nombre: "",
        correo: "",
        telefono: "",
        ciudad: "",
        mensaje: "",
      },
      emptyRule: [(validation) => !!validation || "El Campo  es requerido"],
      emailRule: [
        (validation) => !!validation || "Correo es requerido",
        (validation) =>
          /.+@.+\..+/.test(validation) || "El formato no es correcto",
      ],
      phoneRule: [
        (validation) => !!validation || "Teléfono es requerido ",
        (validation) =>
          /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
            validation
          ) || "El formato no es correcto",
        (validation) =>
          (validation && validation.length <= 10) ||
          "El teléfono debe tener 10 digitos",
      ],
    };
  },
  mounted: function () {
    if (this.locale == "en") {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Contacto?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.contacto = data));
    } else {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Contacto?token=8cf7ca41761951fdde0c1e2cfda401"
      )
        .then((data) => data.json())
        .then((data) => (this.contacto = data));
    }
    this.$gtag.pageview({ page_path: '/contacto', page_title: 'Contacto' })
  },
  computed: {
    locale: function () {
      return this.$i18n.locale;
    },
  },
  watch: {
    locale: function () {
      if (this.locale == "en") {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Contacto?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "en", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.contacto = data));
      } else {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Contacto?token=8cf7ca41761951fdde0c1e2cfda401"
        )
          .then((data) => data.json())
          .then((data) => (this.contacto = data));
      }
    },
  },
  methods: {
    enviarForm: function () {
      fetch(
        "https://nncms.actstudio.xyz/api/forms/submit/Contacto?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            form: this.form,
          }),
        }
      )
        .then((entry) => entry.json())
        .then(() => (this.snackbar = true))
        .then(() => this.$refs.form.reset());
    },
    limpiarForm: function () {
      this.form.nombre = "";
      this.form.ciudad = "";
      this.form.correo = "";
      this.form.telefono = "";
      this.form.mensaje = "";
    },
    validateFields() {
      var result = this.$refs.form.validate();
      if (result) {
        this.enviarForm();
      }
    },
  },
};
</script>
